import { useClient } from '@adamlip/okeoke.client';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ItemCard from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/PreviousOrderElements/ItemCard';

export default function PreviousOrderElements({ element }) {

  const { client, socketAuthenticated, getName } = useClient();
  const [orders, setOrders] = useState(null);
  const [order, setOrder] = useState(null);
  const [orderItems, setOrderItems] = useState(null);

  useEffect(() => {
    if (socketAuthenticated) loadUserOrders();
    // eslint-disable-next-line
  }, [socketAuthenticated]);
  const loadUserOrders = () => {
    client.getUserOrders(moment().subtract(365, 'd').format('YYYY-MM-DD'), moment().add(1, 'days').format('YYYY-MM-DD')).then((res) => {
      setOrders(res.data);
      client?.getUserOrder(res?.data?.[0]?.uuid).then((res) => {
        let arrayWithRemovedDuplicatedItems = [];
        res?.data?.items?.forEach((item) => {
          if (!arrayWithRemovedDuplicatedItems?.find((i) => i?.itemUUID === item?.itemUUID)) {
            arrayWithRemovedDuplicatedItems.push(item);
          }
        });
        setOrderItems(arrayWithRemovedDuplicatedItems);
        setOrder(res.data);
      });
    });
  };
  if (!order) return null;
  if (orderItems?.length < 1) return null;
  return (
    <div className='px-3'>
      {getName(element?.attributes?.label) && <p className='text-lg font-bold mb-2'>{getName(element?.attributes?.label)}</p>}
      {orders && order && (
        <div className='w-full flex flex-row gap-2 overflow-x-scroll pb-4'>
          {orderItems.map((item, index) => {
            return (
              <div className='' key={item?.orderItemUUID}>
                <ItemCard key={item?.orderItemUUID} item={item} order={order} showImage={element?.attributes?.showPreviousOrdersImage} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
